export default "__VITE_PUBLIC_ASSET__43a495e7__"